import { NgModule } from '@angular/core';
import { BackendModule, SearchModule } from '@freelancer/datastore/core';
import { searchActiveProjectsBackend } from './search-active-projects.backend';
import { transformSearchActiveProjects } from './search-active-projects.transformers';

@NgModule({
  imports: [
    SearchModule.forFeature(
      'searchActiveProjects',
      transformSearchActiveProjects,
    ),
    BackendModule.forFeature(
      'searchActiveProjects',
      searchActiveProjectsBackend,
    ),
  ],
})
export class DatastoreSearchActiveProjectsModule {}
